/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useMemo, useState, useContext } from "react";
import { ProjectsTableRow } from "../pages/projects/ProjectsTable";

type ProjectsContextType = {
  leadList: ProjectsTableRow[];
  dealList: ProjectsTableRow[];
  entitySelected: ProjectsTableRow | null;
  setLeadList: React.Dispatch<React.SetStateAction<ProjectsTableRow[]>>;
  setDealList: React.Dispatch<React.SetStateAction<ProjectsTableRow[]>>;
  setEntitySelected: React.Dispatch<
    React.SetStateAction<ProjectsTableRow | null>
  >;
};

export const ProjectsContext = createContext<ProjectsContextType | null>(null);

// ----------------------------------------------------------------------

type ProjectsProviderProps = {
  children: React.ReactNode;
};

export function ProjectsProvider({ children }: ProjectsProviderProps) {
  const [leadList, setLeadList] = useState<ProjectsTableRow[]>([]);
  const [dealList, setDealList] = useState<ProjectsTableRow[]>([]);
  const [entitySelected, setEntitySelected] = useState<ProjectsTableRow | null>(
    null,
  );

  const memoizedValue = useMemo(
    () => ({
      leadList,
      dealList,
      entitySelected,
      setLeadList,
      setDealList,
      setEntitySelected,
    }),
    [
      leadList,
      dealList,
      entitySelected,
      setLeadList,
      setDealList,
      setEntitySelected,
    ],
  );

  return (
    <ProjectsContext.Provider value={memoizedValue}>
      {children}
    </ProjectsContext.Provider>
  );
}

export const useProjectsContext = () => {
  const context = useContext(ProjectsContext);

  if (!context)
    throw new Error(
      "useProjectsContext context must be use inside ProjectsProvider",
    );

  return context;
};
